<template>
<div id="sale_business">
    <div class="info title clearfix" style="background: url('/static/uploads/2017/12/13/16/14/e9e83f096f087aa92ebb713449e80f76.png') 0 0 no-repeat;background-position: center center;">
        <div class="wrapper clearfix">
            <div class="col-xs-120">
                <h1>Продажа бизнеса - агрегатор "В-Автосервис"</h1>
            </div>
        </div>
    </div>
    <div class="container-fluid avtoservices-block">
        <h3 style="color: #4a80c6;"><center><br/>ПРОДАЖА БИЗНЕСА – АГРЕГАТОР ЗАПИСИ АВТОМОБИЛЕЙ НА РЕМОНТ В-АВТОСЕРВИС</center></h3>
    </div>
    <div class="category clearfix category-links" style="padding-bottom: 0px;">
        <div class="wrapper clearfix" style="padding-bottom: 20px;">
            <div class="col-xs-120 text_raw_main_div">
                <p>Мы продаем действующий e-commerce бизнес по ремонту автомобилей в нескольких городах и странах.</p>

                <h2>ЭТО ПОЗВОЛИТ ПОКУПАТЕЛЮ:</h2>
                <ul>
                    <li>Купить готовый действующий на всех платформах бизнес вкладывая только в маркетинг.</li>
                    <li>Купить бизнес без привязки к конкретному месту. IT бизнес позволяет работать где угодно.</li>
                    <li>Начать зарабатывать с первого дня, а не тратить сотни тысяч долларов на разработку, тестирование, внедрение.</li>
                    <li>Получить готовую команду поддержки на 6 месяцев.</li>
                    <li>Развивать собственный франчайзинг.</li>
                    <li>Получить готовый план маркетинга, прошедший все тесты.</li>
                </ul>

                <h2>ЭТО ПОЗВОЛИТ НАМ:</h2>
                <ul>
                    <li>В сочетании с другими бизнес-моделями произвести гораздо более быстрый захват рынков.</li>
                    <li>Продажа в нашем случае выгоднее чем привлекать дополнительные инвестиции на текущей стадии.</li>
                    <li>Сформировать большой пул предпринимателей – единомышленников из разных городов и стран с которыми мы сможем взаимодействовать и развиваться на равных условиях, но гораздо быстрее.</li>
                </ul>

                <h2>ПОЧЕМУ ИМЕННО ЭТОТ БИЗНЕС</h2>
                <ul>
                    <li>Авторынок – один из самых больших в странах СНГ.</li>
                    <li>IT бизнес, не требующий десятков сотрудников, офисов, складов и пр.</li>
                </ul>

                <h2>ГАРАНТИЯ БЕЗОПАСНОЙ СДЕЛКИ</h2>
                <ol>
                    <li>Передаем все права.</li>
                    <li>Передаем все IT решения.</li>
                    <li>Передаем домены/поддомены и пр.</li>
                    <li>Передача всей рабочей документации по организации и управлению.</li>
                    <li>Подписываем обязательство о неразглашении информации и запрете на ведение подобной деятельности!</li>
                </ol>
                <h2>ГАРАНТИЯ ПОДДЕРЖКИ</h2>
                <p>Собственники обеспечивают поддержку на протяжении минимум 6 месяцев.</p>
                <p>Нам очень важно чтобы бизнес работал и развивался – как и было сказано выше, существует очень большая связь между всеми городами и странами – если мы продали один город, один регион или одну страну, команда под тем же брендом продолжает работу в других регионах и странах!!!</p>
                <p>ПИШИТЕ, ОБСУДИМ УСЛОВИЯ <a href="mailto:s@v-avtoservice.com">s@v-avtoservice.com</a></p>
                <p>Viber, whatsapp собственника +79099277286</p>
                <p>ICQ 333494862</p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'SaleBusiness'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SaleBusiness.vue